// extracted by mini-css-extract-plugin
export default {"draftsWrapper":"Drafts_draftsWrapper__2WWW9","title":"Drafts_title__AaF5r","info":"Drafts_info__PEHtf","placeholder":"Drafts_placeholder__NWoUu","closeBtn":"Drafts_closeBtn__nh869"};